import { useTranslate } from "@tolgee/react";

export type CrmContactType = "INDIVIDUAL" | "COMPANY";
export const ALL_CONTACT_TYPES: CrmContactType[] = ["INDIVIDUAL", "COMPANY"];

export function useCrmContactTypes() {
  const { t } = useTranslate(["OrganisationProfile"]);

  const contactTypeLabels: Record<CrmContactType, string> = {
    INDIVIDUAL: t("Individual", {
      ns: "OrganisationProfile",
    }),
    COMPANY: t("Company", {
      ns: "OrganisationProfile",
    }),
  };

  const contactTypeOptions: { value: CrmContactType; label: string }[] =
    Object.entries(contactTypeLabels).map(([value, label]) => ({
      value: value as CrmContactType,
      label,
    }));

  return { contactTypeLabels, contactTypeOptions, ALL_CONTACT_TYPES };
}
